var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBlobHaikei(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "visual",
    viewBox: "0 0 900 600",
    width: 900,
    height: 600,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 900,
    height: 600,
    fill: "#FCAF3C"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(481.7415253285817 292.56523178571933)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M273.7 -311.6C343.5 -267.7 381 -170.7 396 -71.9C411 27 403.4 127.7 358.9 209.4C314.4 291.1 232.9 353.7 148.3 367C63.6 380.3 -24.3 344.3 -115.5 313C-206.7 281.7 -301.3 255.1 -368.7 188.5C-436.2 121.9 -476.6 15.4 -464.3 -86.7C-452 -188.7 -387 -286.2 -300.9 -327.2C-214.7 -368.2 -107.3 -352.6 -2.7 -349.4C102 -346.2 204 -355.4 273.7 -311.6",
    fill: "#BB004B"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlobHaikei);
export default __webpack_public_path__ + "static/media/blob-haikei.743f485c60b98b4a59f30f863b114167.svg";
export { ForwardRef as ReactComponent };